import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
    paper: {
        width: '50%',
        margin: '1rem auto',
        padding: '1rem',
    },
    button: {
        margin: '1rem 0',
        minHeight: '3rem'
    }
})
export default useStyles